// Public configuration only. Keep disabled until provider, mail, customer and
// paid-order attribution checks pass. Never put service-role or OAuth secrets here.
window.TAHPlatformConfig = Object.freeze({
  enabled: false,
  supabaseUrl: 'https://drubymwmhdsygwiammvj.supabase.co',
  publishableKey: 'sb_publishable_IRCS-DEJ5DRZNKN_dDrR_A_o2vw3Urh',
  apiOrigin: 'https://backend.aitokenshop.ai',
  providers: Object.freeze({ google: false, github: false })
});
window.TAHPlatformConfigUrl = 'https://backend.aitokenshop.ai/platform/api/config';
